export const DEFAULT_SSR_RESOURCE_TIMEOUT: number = 1200;

let currentSsrResourceTimeout: number = DEFAULT_SSR_RESOURCE_TIMEOUT;

export const setSsrResourceTimeout = (timeout?: number | null): void => {
	currentSsrResourceTimeout = timeout || DEFAULT_SSR_RESOURCE_TIMEOUT;
};

export const getSsrResourceTimeout = (): number => currentSsrResourceTimeout;

export const ssrResourceTimeout: { get: () => number; set: (timeout?: number | null) => void } = {
	get: getSsrResourceTimeout,
	set: setSsrResourceTimeout,
};
